import { Directive } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'terra-notification-card-title',
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class TerraNotificationCardTitleComponent {}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'terra-notification-card-suffix',
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class TerraNotificationCardSuffixComponent {}
